<template>
  <div class="body-1 text--primary">
    <span class="font-weight-bold">{{ searchedLength }}</span>
    <span> {{ $tc("pluralization.poem", searchedLength) }} </span>
    <span v-if="categories.length">
      <span> {{ $t("statistics.with") }} </span>
      <span v-for="category in categories" :key="category">
        <span>
          {{ $tc(`pluralization.${category}`, stat[category].length) }}</span
        >
        <span class="font-weight-bold"> {{ stat[category].join(", ") }}</span>
      </span>
    </span>
    <span>
      {{
        $t("statistics.outOfFilteredPoemsInTimeline", {
          totalCount: filteredLength
        })
      }}
      {{ $t("statistics.outOfTotalPoems", { totalCount: totalLength }) }}</span
    >
    <span v-if="stat.search">
      <span> {{ $t("statistics.relatedToSearchTerm") }} </span>
      <span class="font-weight-bold"> {{ stat.search }}</span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    searchedLength: {
      type: Number,
      required: true
    },
    filteredLength: {
      type: Number,
      required: true
    },
    totalLength: {
      type: Number,
      required: true
    },
    stat: {
      type: Object,
      required: true
    }
  },
  computed: {
    categories() {
      return ["theme", "mood", "motif"].filter(
        category => !!this.stat[category]
      );
    }
  }
};
</script>

<style scoped></style>
